export function primeVideo(video: HTMLVideoElement): void {
  video.muted = true;
  if (typeof video.play !== "function") return;
  try {
    const pending = video.play();
    if (pending && typeof pending.catch === "function") void pending.catch(() => undefined);
  } catch {
  }
}
